import Button from '../../common/components/button';
import Div from '../../common/components/div';
import TranslatedSpan from '../../common/components/translated.span';

interface LoginButtonSectionProps {
    onClick: Function
    isLoading: boolean
}

export default function LoginButtonSection(props: LoginButtonSectionProps) {
    return <>
        <Div isRow={true} paddingBottom={3} paddingTop={4}>
            <Div cols={5} colsSM={5} colsMD={4} colsLG={3} colsXL={3}>
                <Button
                    color={'teal'}
                    displayAs={'button'}
                    fill={'solid'}
                    id={'login-button'}
                    size={'big'}
                    onClick={props.onClick}
                    isLoading={props.isLoading}
                >
                    <TranslatedSpan english={'Log in'}/>
                </Button>
            </Div>
        </Div>
    </>
}